import React, { useState } from 'react';
import SearchBar from "./Search/SearchBar";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "./State/UserContext";

const NavLink = ({ to, children, onClick }) => {
    const { pathname } = useLocation();
    const active = pathname === to || (to !== '/home' && pathname.startsWith(to));
    return (
        <Link
            to={to}
            onClick={onClick}
            className={`font-medium transition-colors text-sm ${active ? 'text-warm-800' : 'text-warm-500 hover:text-warm-800'}`}
        >
            {children}
        </Link>
    );
};

const MenuBar = () => {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);
    const { user } = useUser();
    const isAdmin = user?.role_id === 1;

    return (
        <nav className="bg-parchment border-b border-warm-200 shadow-sm sticky top-0 z-30">
            <div className="px-4 sm:px-6 py-3 flex items-center justify-between">
                {/* Logo */}
                <Link
                    to="/home"
                    onClick={close}
                    className="flex items-center gap-2 font-serif text-xl font-bold text-warm-800 hover:text-warm-600 transition-colors"
                >
                    <span className="text-2xl">📚</span>
                    <span className="hidden sm:inline">My Books Library</span>
                </Link>

                {/* Desktop nav */}
                <div className="hidden md:flex items-center gap-6">
                    <SearchBar />
                    <NavLink to="/home">Home</NavLink>
                    <NavLink to="/library">Library</NavLink>
                    <NavLink to="/profile">Profile</NavLink>
                    {isAdmin && <NavLink to="/admin">Admin</NavLink>}
                    <Link
                        to="/logout"
                        className="flex items-center gap-1.5 text-warm-500 hover:text-warm-800 font-medium transition-colors text-sm"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
                        </svg>
                        Logout
                    </Link>
                </div>

                {/* Hamburger button — mobile only */}
                <button
                    className="md:hidden p-2 rounded-lg text-warm-600 hover:text-warm-800 hover:bg-warm-100 transition-colors"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                    aria-expanded={open}
                >
                    {open ? (
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    ) : (
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                    )}
                </button>
            </div>

            {/* Mobile drawer */}
            {open && (
                <div className="md:hidden border-t border-warm-200 bg-parchment px-4 py-3 space-y-1">
                    <div className="pb-3">
                        <SearchBar />
                    </div>
                    {[
                        { to: '/home', label: 'Home' },
                        { to: '/library', label: 'Library' },
                        { to: '/profile', label: 'Profile' },
                        ...(isAdmin ? [{ to: '/admin', label: 'Admin' }] : []),
                    ].map(({ to, label }) => (
                        <Link
                            key={to}
                            to={to}
                            onClick={close}
                            className="block px-3 py-2.5 rounded-lg text-warm-700 hover:bg-warm-100 font-medium text-sm transition-colors"
                        >
                            {label}
                        </Link>
                    ))}
                    <Link
                        to="/logout"
                        onClick={close}
                        className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-warm-500 hover:bg-warm-100 font-medium text-sm transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
                        </svg>
                        Logout
                    </Link>
                </div>
            )}
        </nav>
    );
};

export default MenuBar;
